module.exports = __webpack_public_path__ + "assets1783936157458/img/shouye.9196cfab.svg";